import { COURSE_BUNDLES_API } from 'modules/courses/bundles/api/course-bundles-api'
import { CourseBundleApiInterface } from 'modules/courses/bundles/types/course-bundle-interface'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { SwrPaginationInterface } from 'shared/types/pagination-interface'
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string'
import { baseFetcher } from 'shared/utils/http-client'

export function useCourseBundles({ limit, pagination }: SwrPaginationInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, CourseBundleApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: courseBundles, mutate } = useControlledSwr(
    () => [
      `${COURSE_BUNDLES_API}/list?${getPaginationQueryString({ limit, pagination })}`,
      RequestModuleEnum.CourseBundle,
    ],
    fetcher,
    undefined,
    !!user,
  )

  const { data: counter } = useControlledSwr(() => {
    if (user) {
      return [`${COURSE_BUNDLES_API}/count?pagination[limit]`, RequestModuleEnum.CourseBundle]
    }
    return null
  }, baseFetcher)

  return { courseBundles, mutate, counter }
}
